import React from "react";
import Gender from "../options/Gender";
import "./ProfileSections.css";

const ProfilePersonalSection = ({ userData, displayLabelValue }) => {
  // Get gender label from value
  const getGenderLabel = (value) => {
    console.log("Gender value:", value, "Type:", typeof value);

    // Direct mapping for string values from server
    if (value === "1") return "Male";
    if (value === "2") return "Female";
    if (value === "3") return "Others";
    if (value === "4") return "Prefer Not To Say";

    // If not a direct match, try to get label from Gender array
    if (value) {
      const option = Gender.find(
        (item) => String(item.value) === String(value)
      );
      if (option) return option.label;
    }

    return "Not provided";
  };

  return (
    <div className="user-profile-card">
      <div className="user-profile-card-header">
        <h2>Personal Information</h2>
      </div>

      <div className="user-profile-card-content">
        <div className="user-profile-info-grid">
          <div className="user-profile-info-item">
            <label>First Name</label>
            <span>{userData.firstname || "Not provided"}</span>
          </div>

          <div className="user-profile-info-item">
            <label>Last Name</label>
            <span>{userData.lastname || "Not provided"}</span>
          </div>

          <div className="user-profile-info-item">
            <label>Gender</label>
            <span>{getGenderLabel(userData.gender)}</span>
          </div>

          <div className="user-profile-info-item">
            <label>Country</label>
            <span>{userData.country || "Not provided"}</span>
          </div>

          <div className="user-profile-info-item">
            <label>City</label>
            <span>{userData.city || "Not provided"}</span>
          </div>

          <div className="user-profile-info-item">
            <label>State</label>
            <span>
              {userData.state || userData.homestate || "Not provided"}
            </span>
          </div>

          <div className="user-profile-info-item">
            <label>PIN Code</label>
            <span>{userData.pin || "Not provided"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePersonalSection;
